import { Config } from "@/shared/config";

export default {
  oidc: {
    clientId: Config.Okta.ClientId,
    issuer: Config.Okta.Issuer,
    redirectUri: window.location.origin + "/auth/login",
    scopes: ["openid", "profile", "email"],
    pkce: true
  },
  oidcAdmin: {
    clientId: Config.AdminOkta.ClientId,
    issuer: Config.AdminOkta.Issuer,
    redirectUri: window.location.origin + "/admin/login",
    scopes: ["openid", "profile", "email"],
    pkce: true
  },
  features: {
    autoPush: true,
    multiOptionalFactorEnroll: true,
    idpDiscovery: true,
    showPasswordToggleOnSignInPage: true,
    rememberMe: true,
  },
};
